module.exports = __webpack_public_path__ + "static/media/common-market-law.d48683a0.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/common-market-law.png
// module id = 1790
// module chunks = 1